export function estaAutenticado() {
  const token = localStorage.getItem("token");
  return !!token;
}
